<div class="sort-bar col-12 ms-2">
  <div class="d-flex flex-row justify-content-between fw-bold">
    <div class="sort-bar-title d-flex align-items-center">All items</div>

    <div ngbDropdown class="d-flex" [autoClose]="'outside'" role="group">
      <button
        class="nav-link btn text-black d-flex font-size-14 align-items-center mx-2 px-0 justify-content-end dropdown-toggle"
        ngbDropdownToggle
      >
        <span class="icon material-icons pe-2" aria-hidden="true"> sort </span>
        <span>
          Sort By: <ng-container *ngIf="optionSelected != undefined">{{ optionSelected | translate }}</ng-container></span
        >
      </button>
      <div ngbDropdownMenu class="shadow text-center dropdown-menu dropdown-menu-end p-0 sort-dropdown mt-2" #greedyDropdown>
        <div class="d-flex flex-column">
          <button type="button" *ngIf="displayDefaultSort" class="sort-bar-item dropdown-item text-black bg-white py-0 rounded">
            <div class="dropdown-link px-3" (click)="sortByDefault()">
              <span class="sort-bar-options">Default</span>
            </div>
          </button>
          <button
            type="button"
            *ngFor="let option of sortBarOptions"
            class="sort-bar-item sort-bar-options dropdown-item text-black bg-white py-0 rounded"
          >
            <div class="w-100 h-100" *ngIf="!option.shouldToggle; else toggleBehavior">
              <div class="dropdown-link px-3" (click)="sortByProperty(option, option.order)">
                <span *ngIf="option.order === sortOrderType.Ascending">{{ option.labelASC | translate }}</span>
                <span *ngIf="option.order === sortOrderType.Descending">{{ option.labelDESC | translate }}</span>
              </div>
            </div>
            <ng-template class="w-100 h-100" #toggleBehavior>
              <div
                *ngIf="option.order === sortOrderType.Ascending"
                class="dropdown-link px-3"
                (click)="sortByProperty(option, sortOrderType.Descending)"
              >
                <span>{{ option.labelDESC | translate }}</span>
              </div>
              <div
                *ngIf="option.order === sortOrderType.Descending"
                class="dropdown-link px-3"
                (click)="sortByProperty(option, sortOrderType.Ascending)"
              >
                <span>{{ option.labelASC | translate }}</span>
              </div>
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="border-bottom border-disabled mb-4 w-100"></div>
</div>
